import { type FC, useState } from "react";
import { type Poll } from "~/lib/db/poll";

import React, { useMemo } from "react";
import Loading from "../../Loading";

type QuizPostContentProps = {
  poll: Poll;
};

const Histogram = (props) => {
  const { amount, maxAmount, index } = props;
  const color = ["#47cbda", "#acd247", "#dc26af", "#7917d0"];
  const style = useMemo(() => {
    if (maxAmount !== 0) {
      const width = (amount * 100) / maxAmount;
      const style = {
        width: width + "%",
        background: color[index % color.length],
        height: 20 + "px",
      };
      return style;
    } else {
      return {};
    }
  }, [amount, maxAmount]);
  return <div className="histogram rounded-md" style={style}></div>;
};

const QuizPostContent: FC<QuizPostContentProps> = ({ poll }) => {
  const [responseQuiz, setResponseQuiz] = useState([]);
  const [showQuixResult, setShowQuixResult] = useState(false);
  const [answerResponse, setAnswerResponse] = useState(poll.answers);
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState(false);
  const [blockVote, setBlockVote] = useState(false);

  const maxResultes = Math.max(...poll.answers.map((el) => el.answerVote));

  function handleChange(event) {
    if (event.target.name.includes("radio")) {
      if (responseQuiz.includes(event.target.value)) return;

      setResponseQuiz(event.target.value);
      return;
    }
    if (event.target.checked) {
      setResponseQuiz((f) => f.concat([event.target.value]));
      return;
    }
    setResponseQuiz((array) => array.filter((f) => f !== event.target.value));
  }

  const sendVote = async () => {
    if (responseQuiz.length == 0)
      return setError(
        new Error("Devi selezionare almeno una scelta per votare")
      );
    setError(null);
    setLoading(true);

    await fetch(`/api/polls/${poll.questionId}`, {
      method: "POST",
      body: JSON.stringify({
        answers: responseQuiz,
      }),
    })
      .then(async (res) => {
        if (!res.ok) {
          setError(
            new Error("Qualcosa non e' andata a buon fine durante la votazione")
          );
          return;
        }

        const response = await res.json();
        setAnswerResponse(response);
        setShowQuixResult(true);
        setBlockVote(true);
      })
      .catch(setError)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div className="mx-4 mt-8 max-w-[832px] rounded-t-3xl bg-lightBlue px-4 uppercase text-white md:ml-auto md:mr-auto">
        <p className="py-2 text-center font-semibold"> {poll.questionLabel}</p>
      </div>
      <div className=" poll mx-4 max-w-[832px] rounded-b-3xl border-2 border-solid border-lightBlue bg-lightLightBlue p-1 md:ml-auto md:mr-auto">
        <div className="bg-lightLightBlue px-3 pt-5">
          <ul className="columns-1 !pl-0 md:columns-2 md:!pl-28">
            {poll.answers.map((answer, index) => (
              <li className="flex items-center gap-2" key={index}>
                <input
                  name={
                    answer.multiple
                      ? `checkbox_${answer.idQuestion}`
                      : `radio_${answer.idQuestion}`
                  }
                  type={answer.multiple ? "checkbox" : "radio"}
                  id={answer.answerId.toString()}
                  value={answer.answerId.toString()}
                  onChange={handleChange}
                  disabled={blockVote}
                />
                <label htmlFor={answer.answerId.toString()}>
                  {answer.answer}
                </label>
              </li>
            ))}
          </ul>
        </div>
        {error && (
          <div className="mt-8 text-center text-red-500">
            Errore: {error.message}
          </div>
        )}
        <div className="mt-8 flex justify-center gap-4 px-3 pb-5 md:flex-row">
          <button
            className="flex items-center gap-4 rounded-xl bg-lightBlue px-6 py-3 uppercase text-white hover:opacity-90 disabled:cursor-not-allowed disabled:brightness-75"
            disabled={blockVote || loading}
            onClick={() => sendVote()}
          >
            {loading && <Loading />} Vota
          </button>
          {blockVote && (
            <button
              className="rounded-xl bg-lightBlue px-6 py-3 uppercase text-white hover:opacity-90"
              onClick={() => setShowQuixResult(!showQuixResult)}
            >
              {!showQuixResult ? "Mostra" : "Nascondi"} Risultati
            </button>
          )}
        </div>
      </div>
      {showQuixResult && (
        <>
          <div
            id={poll.questionId.toString()}
            className="mx-4 mt-8 max-w-[832px] rounded-t-3xl  bg-lightBlue px-3 uppercase text-white md:ml-auto md:mr-auto"
          >
            <p className="py-2 text-center font-semibold">
              Risposte alla domanda: {poll.questionLabel}
            </p>
          </div>
          <div className="mx-4 max-w-[832px] rounded-b-3xl border-2 border-solid border-lightBlue bg-lightLightBlue p-1 px-3 md:ml-auto md:mr-auto">
            {answerResponse.map((answer, index) => (
              <div key={index} className="my-6 pl-0 md:pl-28">
                <p
                  className={`${
                    maxResultes == answer.answerVote ? "font-bold" : ""
                  }`}
                >
                  {answer.answer}{" "}
                  {`( ${(
                    (answer.answerVote * 100) /
                    answer.totVotes
                  ).toFixed()}%)`}
                </p>
                <div>
                  <Histogram
                    amount={answer.answerVote}
                    maxAmount={answer.totVotes}
                    index={index}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default QuizPostContent;
